import React, { Suspense } from 'react';
import { DDD } from "../lib/ddd/ddd";
import { Helmet } from "react-helmet";
import DDDHelmet from "../components/UI/DDDHelmet";
import classes from "./AddCustomer.module.scss";
const MailCreate = React.lazy(() => import('../components/mailComponents/MailCreate'));

const apiRequestAddress = process.env.REACT_APP_API_ENDPOINT || window.location.origin + "/json.rpc";
const ddd = new DDD(apiRequestAddress);

const MailGenerator = () => {
    return(<>
        <DDDHelmet title="Mail generator"/>
        <div className={`w-100 d-flex flex-column p-1 ${classes.container} h-100`}>
        <Suspense fallback={<div>Loading...</div>}>
            <MailCreate />
        </Suspense>
        </div>
    </>)
}

export default MailGenerator;
